import { Base64 } from 'js-base64'

// 盐
const salting = '1972862sd831hff'

// 数据加密
export const encryptString = (name) => {
    return Base64.encode(name + salting)
}

// 数据解密
export const decodeString = (name) => {
    let decodeName = Base64.decode(name) || ''

    if (decodeName && decodeName.split && decodeName.split(salting) && decodeName.split(salting)[0]) {
        return decodeName.split(salting)[0]
    } else {
        return ''
    }
}